import { render, staticRenderFns } from "./VectorAttrPanel.vue?vue&type=template&id=2efb0a74&scoped=true"
import script from "./VectorAttrPanel.vue?vue&type=script&lang=js"
export * from "./VectorAttrPanel.vue?vue&type=script&lang=js"
import style0 from "./VectorAttrPanel.vue?vue&type=style&index=0&id=2efb0a74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efb0a74",
  null
  
)

export default component.exports